import { AUTH_TYPES } from 'auth/state/service/authApi';
import {
  PAGE_LIMIT,
  SEARCH_TYPES,
  getMRNFromTag,
} from 'state/services/searchApiUtils';
import { PATIENT_TABLE_COLUMN_HEADERS } from 'views/components/Table/utils';
import { fetchApi, getTeamsBaseUrl } from './apiService';

const FILTER_BY_MEMBER = false;

const getSortByParamValue = (sortBy, sortDirection) => {
  switch (sortBy) {
    case PATIENT_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN:
      return `ordering_physician_last_name_${sortDirection}`;

    case PATIENT_TABLE_COLUMN_HEADERS.DOB:
      return `dob_${sortDirection}`;

    case PATIENT_TABLE_COLUMN_HEADERS.CONNECTION_STATUS:
      return `connection_status_${sortDirection}`;

    case PATIENT_TABLE_COLUMN_HEADERS.PRESCRIPTION:
      return `connection_template_${sortDirection}`;

    case PATIENT_TABLE_COLUMN_HEADERS.BILLING_CODE:
      return `billing_code_${sortDirection}`;

    case PATIENT_TABLE_COLUMN_HEADERS.PATIENT:
    default:
      return `last_name_${sortDirection}`;
  }
};

export function searchApiService(
  searchType = SEARCH_TYPES.PATIENT,
  {
    patients = '',
    providers = '',
    pageLimit = PAGE_LIMIT,
    filterByMember = FILTER_BY_MEMBER,
    filterByOrderingPhysicianID,
    filterByBillingCodeID,
    filterByConnectionStatus,
    sortBy,
    sortDirection,
    page,
  },
) {
  let urlPath =
    `/participants/search/${searchType}` +
    `?pageLimit=${pageLimit}` +
    `&filterByMember=${filterByMember}`;

  if (searchType === SEARCH_TYPES.ORDERING_PHYSICIAN) {
    urlPath = `${urlPath}&orderingProviderNames=${encodeURIComponent(
      providers,
    )}`;
  } else {
    urlPath = `${urlPath}&identifier=${encodeURIComponent(
      getMRNFromTag(patients),
    )}`;
  }

  // sort order
  if (sortBy) {
    urlPath = `${urlPath}&sortBy=${getSortByParamValue(
      sortBy,
      sortDirection,
    ).toLowerCase()}`;
  }
  if (page) {
    urlPath = `${urlPath}&page=${page}`;
  }

  // refinement filters
  if (
    filterByOrderingPhysicianID &&
    filterByOrderingPhysicianID !== 'undefined' &&
    filterByOrderingPhysicianID !== 'null' &&
    searchType === SEARCH_TYPES.PATIENT
  ) {
    urlPath = `${urlPath}&orderingPhysicianID=${
      filterByOrderingPhysicianID === 'none'
        ? 'NONE'
        : filterByOrderingPhysicianID
    }`;
  }

  if (
    filterByBillingCodeID &&
    filterByBillingCodeID !== 'undefined' &&
    filterByBillingCodeID !== 'null'
  ) {
    urlPath = `${urlPath}&billingCodeID=${
      filterByBillingCodeID === 'none' ? 'NONE' : filterByBillingCodeID
    }`;
  }

  if (
    filterByConnectionStatus &&
    filterByConnectionStatus !== 'undefined' &&
    filterByConnectionStatus !== 'null'
  ) {
    urlPath = `${urlPath}&connectionStatus=${filterByConnectionStatus}`;
  }

  return fetchApi({
    url: `${getTeamsBaseUrl()}${urlPath}`,
    authType: AUTH_TYPES.BEARER,
  })
    .then(res => res.json())
    .then(res => {
      return {
        results: res.participants,
        hasNextPage: res.has_next_page,
        totalRecords: res.total_objects,
        currentPage: page,
        pageLimit,
      };
    })
    .catch(err => {
      console.log(err);
      throw err;
    });
}



// WEBPACK FOOTER //
// ./src/state/services/searchApi.js